import OADocInfo from './src/info.vue';
/* istanbul ignore next */
OADocInfo.install = function(Vue) {
  Vue.component('oa-doc-info', OADocInfo);
};
export default OADocInfo;


// WEBPACK FOOTER //
// ./src/components/oa/view/basics/docInfo/index.js